import React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import { set, get } from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { shortenStringWithTooltip, roundOff } from '../../../../../Components/helper';
import QuantitesExpandView from './ExpandView/QuantitesExpandView';
import useShowHideSectionHooks from '../Hooks/useShowHideSectionHooks';

export function QuantitiesTable({ checkAccodionActiveState, handleClickToggle, productInfoObj }) {
  const { t } = useTranslation('common');
  const { productCostingstate, setProductCostingState } = productInfoObj;
  const {
    quantities: { quantitiesInfo, overAllSumOfQuantityPerSizCol, totLength, totSize, totColourways },
    detailedCosting: { detailedCostingActive },
    isBreakdown,
  } = productCostingstate;

  const {
    MultiProductSelectReducer: { productLengths },
  } = useSelector((reduxState) => reduxState);

  const { hideLengthCol } = useShowHideSectionHooks(productInfoObj);
  const renderComponent = Array.isArray(quantitiesInfo) && quantitiesInfo.length > 0;

  const expandQuantitiesChild = (index) => {
    const copyState = productCostingstate;
    const path = `quantities.quantitiesInfo[${index}].isExpanded`;
    const expanded = get(copyState, path, false);
    set(copyState, path, !expanded);
    setProductCostingState((state) => ({ ...state, ...copyState }));
  };
  return (
    <Accordion activeKey={checkAccodionActiveState('quantities')} alwaysOpen={detailedCostingActive}>
      <Card className="mb-3">
        <Card.Header>
          <span className="f-16 text-medium">{t('FILTER.QUANTITIES')}</span>
          <Accordion.Toggle
            className="btn-toggle"
            as={Button}
            variant="link"
            eventKey={checkAccodionActiveState('quantities')}
            onClick={() => handleClickToggle('quantities')}
          >
            <i
              className={checkAccodionActiveState('quantities') ? 'icon-new-down-arrow-icon inverse text-grey f-24' : 'icon-new-down-arrow-icon f-24 text-grey'}
            />
          </Accordion.Toggle>
        </Card.Header>

        <Accordion.Collapse eventKey={checkAccodionActiveState('quantities')}>
          <Card.Body className="px-2 py-0">
            <div className="table-responsive average-colourway-table table-max-h-50">
              <table className="table common-class-bottom common-custom-table">
                <thead>
                  {renderComponent && (
                    <tr>
                      <th className="w-50px" />
                      <th className="w-250px">{t('COSTING_TO_DO_LIST.COLORWAY')}</th>
                      <th className="w-250px">{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                      {hideLengthCol && <th className="w-250px">{t('PROGRESS_INDICATOR.LENGTH')}</th>}
                      <th className="w-250px">{t('COSTING_TO_DO_LIST.QUANTITY')}</th>
                    </tr>
                  )}
                </thead>
                {renderComponent ? (
                  <tbody>
                    {quantitiesInfo?.map((data, index) => {
                      return !data?.isExpanded && data?.expandData.length !== 1 && !isBreakdown ? (
                        <tr key={index}>
                          <td>
                            {data?.expandData &&
                              data?.expandData.length > 0 &&
                              (data.isExpanded ? (
                                <button
                                  className="btn-up-down"
                                  type="button"
                                  aria-label={t('COMMON_LABEL.OPEN')}
                                  onClick={() => {
                                    expandQuantitiesChild(index);
                                  }}
                                >
                                  <span className="icon-new-down-arrow-icon icon-inverse" />
                                </button>
                              ) : (
                                <button
                                  className="btn-up-down"
                                  type="button"
                                  aria-label={t('COMMON_LABEL.CLOSE')}
                                  onClick={() => {
                                    expandQuantitiesChild(index);
                                  }}
                                >
                                  <span className="icon-new-down-arrow-icon" />
                                </button>
                              ))}
                          </td>
                          <td>{data?.colourway?.name}</td>
                          <td>{data.isExpanded ? '--' : Array.isArray(totSize) && shortenStringWithTooltip(totSize.join(', '), 15)}</td>
                          {hideLengthCol && <td>{data.isExpanded ? '--' : Array.isArray(totLength) && shortenStringWithTooltip(totLength.join(', '), 25)}</td>}
                          <td className="text-left">{roundOff(data?.sumOfQuantityPerSizCol, 4, true)}</td>
                        </tr>
                      ) : (
                        (data?.isExpanded || data?.expandData.length === 1 || isBreakdown) && (
                          <QuantitesExpandView
                            data={data}
                            index={index}
                            expandQuantitiesChild={expandQuantitiesChild}
                            colourway={data?.colourway}
                            lengthRange={data?.lengthRange}
                            sizeRange={data?.sizeRange}
                            productInfoObj={productInfoObj}
                          />
                        )
                      );
                    })}
                    <tr>
                      <td />

                      <td>
                        <span className="f-16 text-bold">
                          {totColourways?.length > 1 ? `${totColourways.length} Colourway(s)` : `${totColourways.length || 0} Colourway`}
                        </span>
                      </td>
                      <td>
                        <span className="f-16 text-bold">{totSize?.length > 1 ? `${totSize.length} Size(s)` : `${totSize.length || 0} Size`}</span>
                      </td>

                      {productLengths.length > 0 && (
                        <td>
                          <span className="f-16 text-bold">{totLength?.length > 1 ? `${totLength.length} Length(s)` : `${totLength.length || 0} Length`}</span>
                        </td>
                      )}
                      <td className="text-left">
                        <span className="f-16 text-bold">{`${roundOff(overAllSumOfQuantityPerSizCol, 4, true)} Units`}</span>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
              </table>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default QuantitiesTable;
